import { render } from "./ReasonSection.vue?vue&type=template&id=0fcd8372"
import script from "./ReasonSection.vue?vue&type=script&lang=js"
export * from "./ReasonSection.vue?vue&type=script&lang=js"

import "./ReasonSection.vue?vue&type=style&index=0&id=0fcd8372&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__